// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"98":"a52112a5","391":"656c8eb1","447":"ed0205b2","490":"e6fea297","680":"29deacf1","824":"705ece08","870":"9476ca97","896":"bffac868"}[chunkId] + ".css";
};